import React, { useEffect, useState } from 'react'
import moment from 'moment'
import API from '../../../../../services/API'
import { Alert, Grid, LinearProgress, Stack } from '@mui/material'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import { Cancel, CheckCircle } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'

const RIDDOR = ({ event }) => {
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    API.get('/client-portal/riddor-reports-by-event/' + event._id)
      .then((res) => {
        if (res.status === 200) {
          setReports(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    moment(event.startDate).isBefore(moment().subtract(1, 'hour')) && (
      <Grid item xs={12}>
        <DetailsBox title="RIDDOR">
          {loading ? (
            <LinearProgress />
          ) : fetchError ? (
            <Alert severity="error">
              Unable to load H&S Incidents. Please try again later.
            </Alert>
          ) : reports.length === 0 ? (
            <Alert severity="success">
              There are currently no reported Health & Safety Incidents for this
              event.
            </Alert>
          ) : (
            <CustomDataGrid
              columns={[
                {
                  field: 'incidentDate',
                  headerName: 'Date',
                  valueGetter: (value, row) => row.incident.incidentDate,
                  renderCell: ({ value }) =>
                    moment(value).format('Do MMM YYYY HH:mm'),
                  minWidth: 160,
                },
                {
                  field: 'event',
                  headerName: 'Event',
                  valueGetter: (value, row) => row.incident.linkedEvent.title,
                  minWidth: 200,
                  flex: 1,
                },
                {
                  field: 'type',
                  headerName: 'Incident Type',
                  valueGetter: (value, row) =>
                    row.incident?.healthSafetyType ?? [],
                  renderCell: ({ value }) => value.join(', '),
                  minWidth: 120,
                  flex: 1,
                },
                {
                  field: 'ptOutcome',
                  headerName: 'Patient Outcome',
                  valueGetter: (value, row) => row?.plan?.ptOutcome,
                  minWidth: 120,
                  flex: 1,
                },
                {
                  field: 'reviewed',
                  headerName: 'Reviewed',
                  valueGetter: (value, row) =>
                    row.incident.healthSafetyConcernReviewedByOrganiser,
                  renderCell: ({ value }) =>
                    value ? (
                      <CheckCircle color="success" />
                    ) : (
                      <Cancel color="error" />
                    ),
                  minWidth: 120,
                },
              ]}
              rows={reports}
              slots={{
                toolbar: () => null,
                footer: () => null,
              }}
              disableRowSelectionOnClick
              onRowClick={({ row }) =>
                navigate('/health-safety-incidents/' + row._id)
              }
            />
          )}
        </DetailsBox>
      </Grid>
    )
  )
}

export default RIDDOR
